import React from "react";
import { Card, Switch, Space, Typography, Tag, Rate } from "antd";
import { HomeOutlined, UserOutlined, EuroOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

interface AdvertItemProps {
  advert: {
    id: string;
    name: string;
    description: string;
    roomType: string;
    basePrice: number;
  };
  isAssigned: boolean;
  onAssignmentChange: (assign: boolean) => void;
}

export const AdvertItem: React.FC<AdvertItemProps> = ({
  advert,
  isAssigned,
  onAssignmentChange,
}) => {
  return (
    <Card
      size="small"
      style={{
        marginBottom: 8,
        backgroundColor: isAssigned ? '#f6ffed' : '#fafafa',
        border: isAssigned ? '1px solid #b7eb8f' : '1px solid #d9d9d9'
      }}
      bodyStyle={{ padding: '12px 16px' }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
            <HomeOutlined style={{ marginRight: 8, color: '#1890ff' }} />
            <Title level={5} style={{ margin: 0, fontSize: '14px' }}>
              {advert.name}
            </Title>
          </div>
          
          <div style={{ marginBottom: 8 }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {advert.description}
            </Text>
          </div>

          <Space size="small" wrap>
            <Tag icon={<UserOutlined />} color="blue">
              {advert.roomType}
            </Tag>
            <Tag icon={<EuroOutlined />} color="green">
              ab {advert.basePrice}€
            </Tag>
          </Space>
        </div>

        <div style={{ marginLeft: 16 }}>
          <Switch
            checked={isAssigned}
            onChange={onAssignmentChange}
            checkedChildren="✓"
            unCheckedChildren="—"
            size="small"
          />
        </div>
      </div>
    </Card>
  );
}; 